import { render, staticRenderFns } from "./UsedCellsCount.vue?vue&type=template&id=453f6e3e"
import script from "./UsedCellsCount.vue?vue&type=script&lang=js"
export * from "./UsedCellsCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports